const comMain = (() => {
  if (document.querySelector("section#jsComSecMain") !== null) {



    let secMain = document.querySelector('#jsComSecMain');
    let mainWrap = secMain.querySelector('.js-main-wrap');
    let imgBox = mainWrap.querySelector('.js-img-box');


    setTimeout(() => {
      imgBox.classList.add('is-act')
    }, 300);



  }

  ///

  if (document.querySelector("section#jsComSecMain3") !== null) {



    let secMain = document.querySelector('#jsComSecMain3');
    let mainWrap = secMain.querySelector('.js-main-wrap');
    let imgBox = mainWrap.querySelector('.js-img-box');


    setTimeout(() => {
      imgBox.classList.add('is-act')
    }, 300);


    let to = gsap.to('#jsComSecMain3 .js-main-wrap .js-img-box .img', {
      backgroundPosition: '50% 100%',
      ease: "none",
      scrollTrigger: {
        trigger: '#jsComSecMain3',
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0,
        // markers: true
      }
    })

    let to1 = gsap.to('#jsComSecMain3 .js-main-wrap .js-img-box.sticky', {
      ease: "none",
      scrollTrigger: {
        trigger: '#jsComSecMain3 .js-main-wrap .js-img-box.sticky',
        start: 'top top',
        endTrigger: '#jsComSecMain3',
        end: 'bottom bottom',
        pin: true,
        pinSpacing: false,
        // markers: true
      }
    })

    let to2 = gsap.to('#jsComSecMain3 .js-main-wrap .js-img-box .js-cover2', {
      opacity: 1,
      backdropFilter: 'blur(20px)',
      ease: "none",
      scrollTrigger: {
        trigger: '#jsComSecMain3',
        start: '100% 100%',
        end: '100% 0%',
        scrub: 0,
        // markers: true
      }
    })

    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        to.scrollTrigger.refresh()
        to1.scrollTrigger.refresh()
        to2.scrollTrigger.refresh()
        // console.log('comParallax refresh');
      });
    });
    observer.observe(target);



  }
})()
export default comMain;